<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Font Awesome Pro</h1>
					<p waBody="m" waText>Font Awesome Pro 7.2.0 &mdash; 10,000+ premium icons across Regular, Light, Duotone, and Thin styles extending the community Font Awesome plugin. Requires an active Font Awesome Pro subscription.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Font Awesome Pro 7.2.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>Font Awesome Pro requires an active subscription. Get your license at fontawesome.com/plans</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fontawesome-pro</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fontawesome5pro</p>
					<p waBody="s" waText>Built on: Font Awesome Pro 7.2.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_99" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_100" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_101" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>10,000+ premium icons &mdash; complete Font Awesome Pro library</p>
					<p waBody="s" waColorText="quiet" waText>Pro-exclusive styles &mdash; Regular, Light, Duotone, Thin</p>
					<p waBody="s" waColorText="quiet" waText>Extends Font Awesome Free &mdash; Solid and Brand styles included</p>
					<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API with compile-time safety</p>
					<p waBody="s" waColorText="quiet" waText>SVG or Web Font rendering</p>
					<p waBody="s" waColorText="quiet" waText>Icon transformations &mdash; rotate, flip, scale, position</p>
					<p waBody="s" waColorText="quiet" waText>Layering and masking &mdash; combine multiple icons</p>
					<p waBody="s" waColorText="quiet" waText>Animation effects &mdash; spin, pulse, custom animations</p>
					<p waBody="s" waColorText="quiet" waText>Sizing from xs to 10x</p>
					<p waBody="s" waColorText="quiet" waText>Angular FontAwesome module integration</p>
					<p waBody="s" waColorText="quiet" waText>CRTP fluent API for icon configuration</p>
					<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Pro Icon Styles</h4>
						<p waBody="s" waColorText="quiet" waText>Use the extended Pro icon styles &mdash; Regular, Light, Duotone, and Thin.</p>
						<markdown [data]="mdContent_102" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_103" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>FontAwesomeProPageConfigurator registers Pro icon packs &mdash; Regular, Light, Duotone, Thin SVG icons</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
						<wa-tag pill variant="neutral">Font Awesome Pro License</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fontawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fontawesome.com/docs</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FontAwesomePro</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>